import { TransformInt } from '../../../decorators/transform-int.decorator';

import { CreateUserDto } from './create-user.dto';

/**
 * Update user DTO
 */
export class UpdateUserDto extends CreateUserDto {
	@TransformInt()
	id!: number;
}
